import React, { useContext } from 'react';
import { browserHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { PlayerContext } from '../../../context/PlayerContext';
import { hideEpgTransactions } from '../../../actions/epgTransactions/epgTransactions.actions';

export const useEpgTransactions = () => {
  const { liveVideoTagRef } = useContext(PlayerContext);
  const dispatch = useDispatch();
  const isInPlayer = browserHistory
    ?.getCurrentLocation()
    ?.pathname?.includes('watch');

  const handleExitOrCancel = () => {
    dispatch(hideEpgTransactions());
    if (isInPlayer) liveVideoTagRef.current.play();
  };

  return {
    handleExitOrCancel,
  };
};
